const { MediaUpload, MediaUploadCheck } = wp.editor
const { Button } = wp.components

const ImageControl = ({ image, description, attributes, setAttributes }) => {

  return (
    <div className='imageControl'>
      {description && <p>{description}</p>}
      <MediaUploadCheck>
        {attributes[image].src && (
          <div className='imageControl-thumb' style={{ backgroundImage: `url(${attributes[image].src})` }} />
        )}

        <MediaUpload
          onSelect={media => {
            setAttributes({
              [image]: {
                ...attributes[image],
                src: media.url,
                id: media.id,
                alt: media.alt || media.title,
                width: media.width,
                height: media.height
              }
            })
          }}
          allowedTypes={['image']}
          value={attributes[image].id}
          render={({ open }) => (
            <Button isPrimary onClick={open}>
              {attributes[image].src ? 'Alterar imagem' : 'Escolher imagem'}
            </Button>
          )}
        />

        {attributes[image].src && (
          <Button
            isLink
            isDestructive
            onClick={() =>
              setAttributes({ [image]: { ...attributes[image], src: '', id: '', x: 0, y: 0, width: '', height: '' } })
            }
          >
            Remover imagem
          </Button>
        )}
      </MediaUploadCheck>
    </div>
  )
}

export default ImageControl;
